import { useContext } from 'react';
import { FeaturePermissionsContext } from '.';

export default function useFeaturePermissionsContext() {
  return useContext(FeaturePermissionsContext);
}
